import React, { useEffect, useState } from 'react';

interface IDebounceComponentProps {
  /**
   * Delay after which child component will be shown
   *
   * @default 250
   */
  delay?: number;
  children: React.ReactNode;
}

/**
 * Component is used to show child component (Spinner/Loader) after some delay.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export const DebounceComponent = React.memo(({ children, delay = 250 }: IDebounceComponentProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);

    return () => clearTimeout(timer);
  });

  if (!isVisible) {
    return null;
  }
  return <>{children}</>;
});
